module.exports = __webpack_public_path__ + "static/media/2-en.dfd08833.svg";